var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUntagged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2h.969v5.297c0 .547-.13 1.035-.387 1.465A2.708 2.708 0 0 1 7.75 9.773c-.466.245-1.013.368-1.64.368-.628 0-1.175-.123-1.641-.368a2.736 2.736 0 0 1-1.086-1.011A2.813 2.813 0 0 1 3 7.297V2h.969v5.219c0 .39.086.738.258 1.043.171.302.416.54.734.715.32.171.703.257 1.148.257.446 0 .829-.086 1.149-.257.32-.175.565-.413.734-.715.172-.305.258-.653.258-1.043V2z",
    fill: "#500d76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntagged);
export default __webpack_public_path__ + "static/media/untagged.b9c8599250168b4dc0cdfc7df7ef3b3c.svg";
export { ForwardRef as ReactComponent };